import { render, staticRenderFns } from "./PlasiyerTahsilatAnalizGrafigi.vue?vue&type=template&id=59f5793a&scoped=true"
import script from "./PlasiyerTahsilatAnalizGrafigi.vue?vue&type=script&lang=js"
export * from "./PlasiyerTahsilatAnalizGrafigi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f5793a",
  null
  
)

export default component.exports